"use client";

import React from "react";
import {Skeleton, Stack} from "@mui/material";

const TourHeaderButtonsSkeleton = () => (
    <Stack
      sx={{
        flexDirection: {xs: "column", sm: "row"},
        gap: "1.2rem",
        alignItems: "center",
        justifyContent: {xs: "center", lg: "end"},
        width: {xs: "100%", lg: "auto"}
      }}
      data-testid="tour-header-buttons-skeletons"
    >
      <Skeleton width="22.5rem" height="4rem" variant="rounded" sx={{ borderRadius: "25rem" }} />
      <Skeleton width="19rem" height="4rem" variant="rounded" sx={{ borderRadius: "25rem" }} />
    </Stack>
  );

export default TourHeaderButtonsSkeleton;